import React from 'react';

const boxStyle: React.CSSProperties = {
  height: '100%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  fontWeight: 500,
  fontSize: 18,
};

export const CenteredFormMessage: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <div style={boxStyle}>{children}</div>
);
